import { ShowButton, DeleteButton, Stack } from "@pankod/refine-mui";

import { authProvider } from "authProvider";

export default {
  title: "Clienti",
  resource: "users",
  canCreate: false,
  customDataGetter: async () => {
    let user = await authProvider.getUserIdentity();
    return user;
  },
  dataGridParams: (cData) => {
    //cData in this case will contain user info
    if (cData?.role.type == "authenticated") {
      return {
        permanentFilter: [
          { field: "role.name", operator: "eq", value: "client" },
        ],
      };
    } else {
      return {
        permanentFilter: [
          {
            field: "bookings.facility.owner.id",
            operator: "eq",
            value: cData?.id,
          },
          { field: "role.name", operator: "eq", value: "client" },
        ],
      };
    }
  },
  columns: [
    { field: "firstName", headerName: "Nome", flex: 1, minWidth: 200 },
    { field: "lastName", headerName: "Cognome", flex: 1, minWidth: 200 },
    { field: "email", headerName: "Email", flex: 1, minWidth: 300 },
    {
      field: "active",
      headerName: "Attivo",
      flex: 1,
      minWidth: 100,
      valueGetter: ({ row }) => {
        const value = row.active;
        return value ? "Si" : "No";
      },
    },
    {
      headerName: "Azioni",
      field: "actions",
      minWidth: 150,
      renderCell: function render(params) {
        return (
          <Stack direction="row" spacing={1}>
            <ShowButton hideText recordItemId={params.row.id} />
            <DeleteButton hideText recordItemId={params.row.id} />
          </Stack>
        );
      },
    },
  ],
};
